import { Pipe, PipeTransform } from '@angular/core';
import { DateService } from '../services/date/date.service';

@Pipe({ name: 'dateIncrementConvert',pure:false })
export class DateIncrementConvertPipe implements PipeTransform {
  constructor(private dateService:DateService){

  }
  transform(details: any,increment:number, uppercase:boolean,time?:string) {
    let dateStr = ''
    if(increment === 0){
      dateStr = this.dateService.formatToShortDate(details.date,uppercase) + " " + details.fromTimeHour;
    }
    else{
      const lastDate = this.dateService.getLastDateStr({details:details});
      const date = this.dateService.addDays(lastDate,(increment+1));
      dateStr= this.dateService.formatToShortDate(date,uppercase);
      if(time){
        dateStr += " " + time;
      }      
    }
    return dateStr;
  }
}